const Guild = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <defs>
        <clipPath id="a">
          <rect width="30" height="30" fill="#b2b2b2" stroke="#b2b2b2" strokeWidth="1" />
        </clipPath>
      </defs>
      <g>
        <g transform="translate(1.33 3.75)">
          <g transform="translate(0 0)">
            <path
              d="M1.26,69.561h.457V57.645A3.728,3.728,0,0,1,0,54.508a.4.4,0,0,1,.053-.2L3.24,48.731A1.263,1.263,0,0,1,4.334,48.1H23.085a1.263,1.263,0,0,1,1.094.635l3.187,5.578a.4.4,0,0,1,.053.2A3.728,3.728,0,0,1,25.7,57.645V69.561h.457a.4.4,0,0,1,0,.8H1.26a.4.4,0,0,1,0-.8ZM26.589,54.909H25.3a.4.4,0,1,1,0-.8h1.025L23.482,49.13a.458.458,0,0,0-.4-.23H4.334a.458.458,0,0,0-.4.23L1.094,54.106H2.119a.4.4,0,0,1,0,.8H.831a2.925,2.925,0,0,0,5.795,0H3.836a.4.4,0,1,1,0-.8H23.584a.4.4,0,0,1,0,.8h-2.79a2.925,2.925,0,0,0,5.795,0Zm-19.1,0a2.925,2.925,0,0,0,5.794,0Zm6.654,0a2.925,2.925,0,0,0,5.794,0ZM4.667,69.561H9.015V68.218H4.667Zm0-2.147H9.015V60.061H4.667ZM2.52,69.561H3.864v-9.9a.4.4,0,0,1,.4-.4H9.417a.4.4,0,0,1,.4.4v9.9H24.9V58.034a3.725,3.725,0,0,1-4.535-1.844,3.728,3.728,0,0,1-6.654,0,3.728,3.728,0,0,1-6.654,0A3.725,3.725,0,0,1,2.52,58.035Z"
              transform="translate(0 -48.096)"
              fill="#b2b2b2"
              stroke="#b2b2b2"
              strokeWidth="0.2"
            />
          </g>
          <g transform="translate(11.162 11.162)">
            <path
              d="M72.547,256.516H84.138a.4.4,0,0,1,.4.4v8.157a.4.4,0,0,1-.4.4H72.547a.4.4,0,0,1-.4-.4v-8.157A.4.4,0,0,1,72.547,256.516Zm.4,8.157H83.736v-7.353H72.948Z"
              transform="translate(-72.145 -256.516)"
              fill="#b2b2b2"
              stroke="#b2b2b2"
              strokeWidth="0.2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Guild;
